import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useForm } from 'react-hook-form'

import { getUser, setEmailVerificationCode, setStep } from './state'

import { EmailVerificationInput } from '../../../components/Forms/EmailVerification'
import { Main } from '../../../components'
import {
  useCreateEmailVerificationCodeMutation,
  useVerifyEmailVerificationCodeMutation,
} from '../../../remote/graphql'
import { useCreateOrganization } from '../../../hooks/useCreateOrganization'
import { CreateSteps } from './CreateSteps'
import { FormattedMessage } from 'react-intl'

type VerificationCodeForm = {
  verificationCode: string
}
export function EmailVerificationForm({
  superEnabled,
}: {
  superEnabled: boolean
}) {
  const dispatch = useDispatch()
  const user = useSelector(getUser)

  const { control, setError } = useForm<VerificationCodeForm>({
    mode: 'onChange',
    defaultValues: { verificationCode: '' },
  })

  const [, { loading, error }] = useCreateOrganization()

  const [verifyEmail] = useVerifyEmailVerificationCodeMutation()
  const [createEmailVerificationCode] = useCreateEmailVerificationCodeMutation()

  const onInputChange = useCallback(
    async (code: string) => {
      if (code.length === 6) {
        const { data } = await verifyEmail({
          variables: {
            email: user.email,
            emailVerificationCode: code,
            fromOrganizationCreation: true,
            fromSuper: superEnabled,
          },
        })
        if (data?.verifyEmailVerificationCode) {
          dispatch(setEmailVerificationCode(code))
          dispatch(setStep(CreateSteps.JoinableTeams))
        } else {
          setError('verificationCode', {
            type: 'server',
            message: 'This verification code is invalid',
          })
        }
      }
    },
    [dispatch, setError, user.email, verifyEmail, superEnabled]
  )

  return (
    <Main.Container>
      <Main.Title>
        <FormattedMessage
          id="boarding.emailVerification.title"
          defaultMessage="Verify your email address"
          values={{}}
        />
      </Main.Title>
      <EmailVerificationInput<VerificationCodeForm>
        control={control}
        name="verificationCode"
        email={user.email}
        loading={loading}
        codeError={error?.message}
        onInputChange={onInputChange}
        handleResend={() =>
          createEmailVerificationCode({
            variables: {
              input: { email: user.email, fromSuper: superEnabled },
            },
          })
        }
      />
    </Main.Container>
  )
}
